/*eslint no-script-url: 0 */
import React, { Component } from "react";
import { Modal, Button } from 'react-bootstrap';
import ImageFile from './ImageFile';

class UploadImage extends Component {

	constructor(props) {
        super(props);
        this.state = {
			lgShow: false,
			isUploading: false,
			showPrintPopup: false,
		}
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleOkay = this.handleOkay.bind(this);
    }

	lgClose = () => {
		this.setState({ lgShow: false });
	}

	lgShow = () => {
		this.props.toggleSteps();
		this.setState({ lgShow: true, isUploading: true })
	}

	isUploadingFalse = () => {
		this.setState({ isUploading: false })
	}

	handleClose() {		
		var printID = 0;
		this.props.printing.filter( ( print ) =>
          	'No Printing Required' === print.getIn(['title', 'rendered'])
        ).map( ( print ) =>
        	printID = print.get('id')
        )
        this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedPrint: printID
			}
		})
		this.setState({ showPrintPopup: false });
	}

	handleShow() {
		this.setState({ showPrintPopup: true });
	}

	handleOkay() {		
		var printID = 0;
		this.props.printing.filter( ( print ) =>
          	'High Gloss' === print.getIn(['title', 'rendered'])
        ).map( ( print ) =>
        	printID = print.get('id')
		)
        this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedPrint: printID
			}
		})
		this.setState({ showPrintPopup: false });
	}

 	render() {
		const { isUploading, lgShow, showPrintPopup } = this.state;
	    return (
			<li className="m-b-5">
				<a href="#!" onClick={this.lgShow} className="btn btn-primary default-btn">Upload Image</a>
				{isUploading &&
					<Modal
						show={lgShow}
						onHide={this.lgClose}
						bsSize="large"
						aria-labelledby="contained-modal-title-lg"
					>
						<Modal.Header closeButton>
							<Modal.Title id="contained-modal-title-lg">Upload an Image</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<ImageFile
								{...this.props}
								lgClose={this.lgClose}
								isUploadingFalse={this.isUploadingFalse}
								handleShow={this.handleShow}
							/>
						</Modal.Body>
					</Modal>
				}
				<Modal
					show={showPrintPopup}
					onHide={this.handleClose}
				>
					<Modal.Header closeButton>
						<Modal.Title id="contained-modal-title-lg">Printing</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>Would you like us to print the uploaded image and have it framed?</p>
					</Modal.Body>
					<Modal.Footer>
						<Button className="btn btn-primary btn-danger" onClick={this.handleClose}>No</Button>
						<Button className="btn btn-primary btn-default" onClick={this.handleOkay}>Yes</Button>
					</Modal.Footer>
				</Modal>
			</li>
	    );
  	}
}
export default UploadImage;